import React from 'react'
import classNames from 'classnames'
import IFace from 'emailThreadViewer/ViewerIFace'
import styles from './styles.module.scss'
import { getUserEmail } from 'emailThreadViewer/helper/utils'
import i18n from 'i18n'

interface NameOrEmailProps {
  name?: string
  email?: string
}

const NameOrEmail: React.FC<NameOrEmailProps> = ({ name, email }) => {
  const userEmail = getUserEmail()
  const isMe = email === userEmail

  const handleClick = (): void => {
    if (!email) return
    IFace.WebToNative.showContact(email, name)
  }

  return (
    <span
      className={classNames(styles.nameOrEmail, {
        [styles.pointer]: email,
        [styles.highlight]: name && email && name !== email,
      })}
      onClick={handleClick}
    >
      {isMe ? i18n.t('email.aiExtraction.me') : !name || name === email ? email : name}
    </span>
  )
}

export default NameOrEmail
